import WaybillTemplateType from "@/enum/WaybillTemplateType";

const WaybillTemplateTypeNameMap = {
    [WaybillTemplateType.NORMAL]: "普通快递单",

    [WaybillTemplateType.TAOBAO_CAINIAO]: "淘宝菜鸟电子面单",

    [WaybillTemplateType.CAINIAO]: "菜鸟电子面单",

    [WaybillTemplateType.OFFICIAL]: "快递官方电子面单",

    [WaybillTemplateType.JD]: "京东电子面单",

    [WaybillTemplateType.JDL]: "京东物流云电子面单",

    [WaybillTemplateType.PDD]: "拼多多店铺电子面单",

    [WaybillTemplateType.JINRITEMAI]: "抖音电子面单",

    [WaybillTemplateType.KWAISHOP]: "快手电子面单",

    [WaybillTemplateType.WEBUY]: "鲸灵电子面单",

    [WaybillTemplateType.CHANNEL_SHOP]: "微信小店电子面单",

    [WaybillTemplateType.XIAOHONGSHU]: "小红书电子面单",

    [WaybillTemplateType.AIKUCUN]: "爱库存电子面单",
};

export default WaybillTemplateTypeNameMap;
